export default __webpack_public_path__ + "static/media/seo.ae7c48c6.png";